// @ts-nocheck
import { Paragraph, TextRun, ImageRun, Header, PageBreak } from 'docx';
import logoDefensoria from '/img/logo_branco.png';
import rodapeBr from '/img/rodape_br.jpeg';

export function tituloPrincipal(): Paragraph {
  return new Paragraph({
    children: [
      new TextRun({
        text: 'TERMO DE COMPROMISSO N.º 007/2024 – ESTÁCIO/DIR',
        bold: true,
        size: 24,
        color: 'FF0000',
      }),
    ],
    alignment: 'center',
    spacing: { after: 400 },
  });
}

export function imageLogo(): Header {
  return new Header({
    children: [
      new Paragraph({
        children: [
          new ImageRun({
            data: fetch(logoDefensoria).then((response) => response.blob()),
            transformation: {
              width: 150, // Largura da imagem, ajustada conforme necessário
              height: 150, // Altura da imagem
            },
          }),
        ],
        alignment: 'center', // Alinhar no centro, caso deseje
      }),
    ],
  });
}

export function rodapeLogo(): Paragraph {
  return new Paragraph({
    children: [
      new ImageRun({
        data: fetch(rodapeBr).then((response) => response.blob()),
        transformation: {
          width: 600,
          height: 20,
        },
      }),
    ],
    alignment: 'center',
    spacing: { after: 170 },
  });
}

export function subTituloConcedente(): Paragraph {
  return new Paragraph({
    text: 'CONCEDENTE',
    shading: { fill: 'D3D3D3' },
    bold: true,
    allCaps: true,
    size: 24,
    alignment: 'center',
  });
}

export function subTituloEstagiario(): Paragraph {
  return new Paragraph({
    text: 'ESTAGIÁRIO(A)',
    shading: { fill: 'D3D3D3' },
    bold: true,
    allCaps: true,
    size: 24,
    alignment: 'center',
  });
}

export function subTituloInstituicao(): Paragraph {
  return new Paragraph({
    text: 'INSTITUIÇÃO DE ENSINO',
    shading: { fill: 'D3D3D3' },
    bold: true,
    allCaps: true,
    size: 24,
    alignment: 'center',
  });
}

export function representante(): Paragraph {
  return new Paragraph({
    text: 'REPRESENTANTE',
    shading: { fill: 'D3D3D3' },
    bold: true,
    allCaps: true,
    size: 24,
    alignment: 'center',
  });
}

export function paragrafoVazio(): Paragraph {
  return new Paragraph({
    alignment: 'center',
  });
}

export function termoCompromisso(): Paragraph {
  return new Paragraph({
    text: 'Termo de Compromisso de Estágio que entre si celebram as partes acima qualificadas, de acordo com a Lei nº 11.788/2008, nos termos e condições que seguem:',
    bold: true,
    allCaps: true,
    padding: { top: 0, right: 10, bottom: 110, left: 10 },
    size: 18,
    alignment: 'center',
  });
}

export function clausula(): Paragraph {
  return new Paragraph({
    children: [
      new TextRun({
        text: 'CLÁUSULA I - DO OBJETO:',
        bold: true,
        size: 23,
        alignment: 'left',
      }),
    ],
  });
}

export function presenteObjeto(): Paragraph {
  return new Paragraph({
    text: 'O presente instrumento tem por objeto a concessão de estágio não obrigatório, nos termos estabelecidos na Lei nº 11.788/2008, desenvolvido em ambiente de trabalho e com a finalidade de preparar o estagiário para o trabalho produtivo.',
    bold: true,
    allCaps: true,
    padding: { top: 0, right: 10, bottom: 110, left: 10 },
    size: 18,
    alignment: 'center',
  });
}

export function paragrafoPrimeiro(): Paragraph {
  return new Paragraph({
    children: [
      new TextRun({
        text: 'Parágrafo primeiro - ',
        bold: true,
        allCaps: true,
        padding: { top: 0, right: 10, bottom: 110, left: 10 },
        size: 18,
        alignment: 'center',
      }),
      new TextRun({
        text: 'O estágio não obrigatório é desenvolvido como atividade opcional, sendo esta acrescida à carga horária regular e obrigatória do curso de acordo com as normas internas da instituição de ensino.',
      }),
    ],
    spacing: { before: 310 },
  });
}

export function paragrafoSegundo(): Paragraph {
  return new Paragraph({
    children: [
      new TextRun({
        text: 'Parágrafo segundo - ',
        bold: true,
        allCaps: true,
        padding: { top: 0, right: 10, bottom: 110, left: 10 },
        size: 18,
        alignment: 'center',
      }),
      new TextRun({
        text: 'O estagiário, em compatibilidade com a programação curricular de seu curso, desenvolverá as seguintes atividades:',
      }),
      new PageBreak(),
    ],
    spacing: { before: 710 },
  });
}

export function paragrafoAcompanhamento(): Paragraph {
  return new Paragraph({
    children: [
      new TextRun({
        text: 'Acompanhamento de feitos judiciais, elaboração de peças processuais, visita às delegacias metropolitanas de polícia, presídios, juízos e demais estabelecimentos, entrevistas e seleções de jurisdicionados e outros pertinentes às atividades da Defensoria Pública do Estado de Sergipe.',
        color: 'FF0000',
        size: 19,
      }),
    ],
    alignment: 'center',
    spacing: { before: 910 },
  });
}

export function clausula2(): Paragraph {
  return new Paragraph({
    children: [
      new TextRun({
        text: 'CLÁUSULA II - DA DURAÇÃO:',
        bold: true,
        size: 23,
        alignment: 'left',
      }),
    ],
    spacing: { before: 310 },
  });
}

export function paragrafoDuracao(): Paragraph {
  return new Paragraph({
    children: [
      new TextRun({
        text: 'A duração do estágio terá início em 04/09/2024 e término em 03/09/2025, podendo haver prorrogação, por intermédio de termo aditivo, desde que não ultrapasse o prazo máximo de 02 (dois) anos.',
        size: 19,
      }),
    ],
    alignment: 'center',
    spacing: { before: 310 },
  });
}

export function clausula3(): Paragraph {
  return new Paragraph({
    children: [
      new TextRun({
        text: 'CLÁUSULA III - DA CARGA HORÁRIA:',
        bold: true,
        size: 23,
        alignment: 'left',
      }),
    ],
    spacing: { before: 310 },
  });
}

export function paragrafoAtividade(): Paragraph {
  return new Paragraph({
    children: [
      new TextRun({
        text: 'As atividades de estágio serão desenvolvidas pelo estagiário no período exposto na tabela abaixo, não excedendo a carga horária de 04 (quatro) horas diárias e 20 (vinte) horas semanais.',
        size: 19,
      }),
    ],
    alignment: 'center',
    spacing: { before: 310, after: 250 },
  });
}

export function paragrafoUnico(): Paragraph {
  return new Paragraph({
    children: [
      new TextRun({
        text: 'Parágrafo único - ',
        bold: true,
        allCaps: true,
        padding: { top: 0, right: 10, bottom: 110, left: 10 },
        size: 18,
        alignment: 'center',
      }),
      new TextRun({
        text: 'nos períodos de avaliação escolar, para verificação de aprendizagem do estagiário, a carga horária será reduzida pelo menos a metade, para fins de garantia de desempenho.',
      }),
    ],
    spacing: { before: 320 },
  });
}

export function paragrafo4(): Paragraph {
  return new Paragraph({
    children: [
      new TextRun({
        text: 'CLÁUSULA IV - DA BOLSA ESTÁGIO E DO AUXÍLIO TRANSPORTE: ',
        bold: true,
        allCaps: true,
        padding: { top: 0, right: 10, bottom: 110, left: 10 },
        size: 18,
        alignment: 'center',
      }),
      new TextRun({
        text: 'O estagiário receberá, a título de bolsa de estudos, o valor de R$ 700,00.',
      }),
    ],
    spacing: { before: 320 },
  });
}

export function paragrafoEstagio(): Paragraph {
  return new Paragraph({
    children: [
      new TextRun({
        text: 'Parágrafo único - ',
        bold: true,
        allCaps: true,
        padding: { top: 0, right: 10, bottom: 110, left: 10 },
        size: 18,
        alignment: 'center',
      }),
      new TextRun({
        text: 'O estagiário receberá, também, auxílio transporte no valor de R$ 121,00.',
      }),
    ],
    spacing: { before: 320 },
  });
}

export function paragrafo5(): Paragraph {
  return new Paragraph({
    children: [
      new TextRun({
        text: 'CLÁUSULA V - DO PERÍODO DE RECESSO:',
        bold: true,
        allCaps: true,
        padding: { top: 0, right: 10, bottom: 110, left: 10 },
        size: 18,
        alignment: 'center',
      }),
    ],
    spacing: { before: 320 },
  });
}

export function paragrafoCaso(): Paragraph {
  return new Paragraph({
    children: [
      new TextRun({
        text: 'Caso o estágio tenha duração igual ou superior a 01 (um) ano, o estagiário terá direito a período de recesso remunerado de 30 (trinta) dias, a ser gozado preferencialmente no período de suas férias escolares.',
      }),
    ],
    spacing: { before: 210 },
  });
}

export function paragrafoUnico2(): Paragraph {
  return new Paragraph({
    children: [
      new TextRun({
        text: 'Parágrafo único - ',
        bold: true,
        allCaps: true,
        padding: { top: 0, right: 10, bottom: 110, left: 10 },
        size: 18,
        alignment: 'center',
      }),
      new TextRun({
        text: 'Nos casos de estágio com duração inferior a 01 (um) ano, o período de recesso acima estabelecido será proporcional.',
      }),
    ],
    spacing: { before: 320 },
  });
}

export function paragrafo6(): Paragraph {
  return new Paragraph({
    children: [
      new TextRun({
        text: 'CLÁUSULA VI - DAS OBRIGAÇÕES DA CONCEDENTE:',
        bold: true,
        allCaps: true,
        padding: { top: 0, right: 10, bottom: 110, left: 10 },
        size: 18,
        alignment: 'center',
      }),
    ],
    spacing: { before: 320 },
  });
}

export function paragrafoPrimeiro1(): Paragraph {
  return new Paragraph({
    children: [
      new TextRun({
        text: 'Parágrafo primeiro - ',
        bold: true,
        allCaps: true,
        padding: { top: 0, right: 10, bottom: 110, left: 10 },
        size: 18,
        alignment: 'center',
      }),
      new TextRun({
        text: 'Proporcionar ao estagiário instalações que propiciem a prática de atividades em complementação ao ensino e à aprendizagem da profissão pertinente ao curso no qual está matriculado, visando o desenvolvimento profissional, social e cultural.',
      }),
    ],
    spacing: { before: 400 },
  });
}

export function paragrafoPrimeiro2(): Paragraph {
  return new Paragraph({
    children: [
      new TextRun({
        text: 'Parágrafo segundo - ',
        bold: true,
        allCaps: true,
        padding: { top: 0, right: 10, bottom: 110, left: 10 },
        size: 18,
        alignment: 'center',
      }),
      new TextRun({
        text: 'Indicar funcionário do seu quadro de pessoal, com formação ou experiência profissional na área de conhecimento desenvolvida no curso do estagiário, para orientar e supervisionar até 10 (dez) estagiários simultaneamente.',
      }),
      new PageBreak(),
    ],
    spacing: { before: 400 },
  });
}

export function paragrafoPrimeiro3(): Paragraph {
  return new Paragraph({
    children: [
      new TextRun({
        text: 'Parágrafo terceiro - ',
        bold: true,
        allCaps: true,
        padding: { top: 0, right: 10, bottom: 110, left: 10 },
        size: 18,
        alignment: 'center',
      }),
      new TextRun({
        text: 'Entregar, quando do desligamento do estagiário, termo de realização de estágio com indicação resumida das atividades desenvolvidas, dos períodos e da avaliação de desempenho.',
      }),
    ],
    spacing: { before: 400 },
  });
}

export function paragrafoPrimeiro4(): Paragraph {
  return new Paragraph({
    children: [
      new TextRun({
        text: 'Parágrafo quarto - ',
        bold: true,
        allCaps: true,
        padding: { top: 0, right: 10, bottom: 110, left: 10 },
        size: 18,
        alignment: 'center',
      }),
      new TextRun({
        text: 'Enviar à concedente, quando do início de cada período letivo, as datas de realização das avaliações.',
      }),
    ],
    spacing: { before: 400 },
  });
}

export function clausula4(): Paragraph {
  return new Paragraph({
    children: [
      new TextRun({
        text: 'CLÁUSULA IX - DA RESCISÃO:',
        bold: true,
        size: 23,
        alignment: 'left',
      }),
    ],
    spacing: { before: 310 },
  });
}

export function paragrafoPresente(): Paragraph {
  return new Paragraph({
    children: [
      new TextRun({
        text: 'O presente termo de compromisso será automaticamente rescindido, na ocorrência das seguintes hipóteses:',
      }),
    ],
    spacing: { before: 210 },
  });
}

export function paragrafoLetras(): Paragraph {
  return new Paragraph({
    children: [
      new TextRun({
        text: 'a) Cancelamento ou trancamento da matrícula do estagiário na instituição de ensino;',
      }),
      new TextRun({
        break: 1,
      }),
      new TextRun({
        text: 'b) Transferência do estagiário para outra instituição de ensino superior;',
      }),
      new TextRun({
        break: 1,
      }),
      new TextRun({
        text: 'c) Conclusão ou abandono do curso pelo estagiário;',
      }),
      new TextRun({
        break: 1,
      }),
      new TextRun({
        text: 'd) Término do prazo de vigência do termo de compromisso;',
      }),
      new TextRun({
        break: 1,
      }),
      new TextRun({
        text: 'e) A pedido do estagiário;',
      }),
      new TextRun({
        break: 1,
      }),
      new TextRun({
        text: 'f) Descumprimento pelo estagiário das condições estabelecidas no presente termo de compromisso;',
      }),
      new TextRun({
        break: 1,
      }),
      new TextRun({
        text: 'g) Rendimento insatisfatório do estagiário em relação às atividades desenvolvidas pelo mesmo;',
      }),
      new TextRun({
        break: 1,
      }),
      new TextRun({
        text: 'h) Comportamento funcional ou social inadequado do estagiário;',
      }),
      new TextRun({
        break: 1,
      }),
      new TextRun({
        text: 'i) Interesse e conveniência da concedente.',
      }),
    ],
    spacing: { before: 210 },
  });
}
export function clausula5(): Paragraph {
  return new Paragraph({
    children: [
      new TextRun({
        text: 'CLÁUSULA IX - DA RESCISÃO:',
        bold: true,
        size: 23,
        alignment: 'left',
      }),
    ],
    spacing: { before: 310 },
  });
}

export function paragrafoEstagiario(): Paragraph {
  return new Paragraph({
    children: [
      new TextRun({
        text: 'O estágio não gera qualquer vínculo empregatício do estagiário com a concedente de estágio, nos termos dos arts. 3º, 12, § 1º da Lei nº 11.788, de 25 de setembro de 2008.',
      }),
    ],
    spacing: { before: 210 },
  });
}

export function clausula6(): Paragraph {
  return new Paragraph({
    children: [
      new TextRun({
        text: 'CLÁUSULA XI - DA PROTEÇÃO DE DADOS PESSOAIS, SIGILO E CONFIDENCIALIDADE:',
        bold: true,
        size: 23,
        alignment: 'left',
      }),
    ],
    spacing: { before: 310 },
  });
}

export function paragrafoParticipante(): Paragraph {
  return new Paragraph({
    children: [
      new TextRun({
        text: 'Os partícipes deste termo de compromisso (estagiário, concedente e instituição de ensino) declaram ter conhecimento das regras da Lei Geral de Proteção de Dados, se comprometendo a observá-las no cumprimento das obrigações assumidas em razão dessa relação, na medida de suas atividades e responsabilidades.',
      }),
    ],
    spacing: { before: 210 },
  });
}
export function paragrafoPrimeiro5(): Paragraph {
  return new Paragraph({
    children: [
      new TextRun({
        text: 'Parágrafo primeiro - ',
        bold: true,
        allCaps: true,
        padding: { top: 0, right: 10, bottom: 110, left: 10 },
        size: 18,
        alignment: 'center',
      }),
      new TextRun({
        text: 'A concedente poderá tratar dados pessoais do estagiário, inclusive transferi-los e compartilhá-los para outras empresas ou organizações que estejam em conformidade com a Lei Geral de Proteção de Dados - LGPD e tenham estabelecido e adotado medidas de segurança da informação, desde que tais ações sejam necessárias para o desenvolvimento dos procedimentos e atividades da concedente e estejam fundamentadas por uma das bases legais que autorizam o tratamento, registrando, aqui, o seu devido consentimento.',
      }),
    ],
    spacing: { before: 400 },
  });
}

export function paragrafoPrimeiro6(): Paragraph {
  return new Paragraph({
    children: [
      new TextRun({
        text: 'Parágrafo segundo - ',
        bold: true,
        allCaps: true,
        padding: { top: 0, right: 10, bottom: 110, left: 10 },
        size: 18,
        alignment: 'center',
      }),
      new TextRun({
        text: 'Em nenhum caso, os dados pessoais do estagiário serão expostos sem causa ou justificação que ponha em perigo a sua integridade física ou moral.',
      }),
    ],
    spacing: { before: 400 },
  });
}

export function paragrafoPrimeiro7(): Paragraph {
  return new Paragraph({
    children: [
      new TextRun({
        text: 'Parágrafo terceiro - ',
        bold: true,
        allCaps: true,
        padding: { top: 0, right: 10, bottom: 110, left: 10 },
        size: 18,
        alignment: 'center',
      }),
      new TextRun({
        text: 'Neste ato, o estagiário declara estar ciente de que a concedente possui política de privacidade e tratamento de dados pessoais, que respeita e observa as legislações pertinentes sobre o tema, em que o objetivo é informá-lo sobre a importância da privacidade no ambiente de trabalho e sobre a necessidade de pautar suas atividades de estágio em consonância com os termos das políticas internas e da LGPD.',
      }),
      new PageBreak(),
    ],
    spacing: { before: 400 },
  });
}

export function paragrafoPrimeiro8(): Paragraph {
  return new Paragraph({
    children: [
      new TextRun({
        text: 'Parágrafo quarto - ',
        bold: true,
        allCaps: true,
        padding: { top: 0, right: 10, bottom: 110, left: 10 },
        size: 18,
        alignment: 'center',
      }),
      new TextRun({
        text: 'No âmbito da relação de estágio regida por este termo, o estagiário deverá observar a devida reserva em relação a todas as informações de natureza técnica, administrativa, financeira, processual ou confidencial que sejam de propriedade da concedente ou de seus participantes e/ou qualquer outra pessoa ou instituição a que tenha acesso no exercício de suas funções. Da mesma forma, o estagiário compromete-se a cumprir a missão que lhe foi confiada com a devida diligência e respeito às normas que vinculam a entidade ao cumprimento da Lei Federal nº 11.788/2008 (Lei de Estágio).',
      }),
    ],
    spacing: { before: 400 },
  });
}

export function paragrafoPrimeiro9(): Paragraph {
  return new Paragraph({
    children: [
      new TextRun({
        text: 'Parágrafo quinto - ',
        bold: true,
        allCaps: true,
        padding: { top: 0, right: 10, bottom: 110, left: 10 },
        size: 18,
        alignment: 'center',
      }),
      new TextRun({
        text: 'Fica entendido e acordado pelas partes que, durante e após o término da relação contratual, o estagiário tem a obrigação de manter total confidencialidade em relação aos assuntos descritos neste termo e aos quais tenha acesso em virtude de suas funções.',
      }),
    ],
    spacing: { before: 400 },
  });
}

export function paragrafoPrimeiro10(): Paragraph {
  return new Paragraph({
    children: [
      new TextRun({
        text: 'Parágrafo sexto - ',
        bold: true,
        allCaps: true,
        padding: { top: 0, right: 10, bottom: 110, left: 10 },
        size: 18,
        alignment: 'center',
      }),
      new TextRun({
        text: 'O estagiário - para os casos em que parte de suas responsabilidades e tarefas, dentro da concedente, seja participar do tratamento de dados pessoais – compromete-se a respeitar a confidencialidade e o sigilo dos mesmos. Neste sentido, e de acordo com as Leis e os padrões locais e internacionais de proteção de dados, fica proibida a divulgação a terceiros desses dados pessoais que estão sendo tratados para a realização de seu trabalho, ao menos que haja uma base ou princípio legal que justifique essa ação.',
      }),
    ],
    spacing: { before: 400 },
  });
}

export function paragrafoPrimeiro11(): Paragraph {
  return new Paragraph({
    children: [
      new TextRun({
        text: 'Parágrafo sétimo - ',
        bold: true,
        allCaps: true,
        padding: { top: 0, right: 10, bottom: 110, left: 10 },
        size: 18,
        alignment: 'center',
      }),
      new TextRun({
        text: 'Em qualquer caso, os dados pessoais só poderão ser compartilhados com as autoridades locais em virtude das obrigações estabelecidas na legislação em vigor e após o cumprimento dos procedimentos e requisitos nela estabelecidos.',
      }),
    ],
    spacing: { before: 400 },
  });
}

export function paragrafoPrimeiro12(): Paragraph {
  return new Paragraph({
    children: [
      new TextRun({
        text: 'Parágrafo oitavo - ',
        bold: true,
        allCaps: true,
        padding: { top: 0, right: 10, bottom: 110, left: 10 },
        size: 18,
        alignment: 'center',
      }),
      new TextRun({
        text: 'O estagiário cientifica-se que o tratamento dos dados pessoais deve ser sempre realizado com base nos princípios da finalidade, adequação, necessidade, livre acesso, qualidade dos dados, transparência, segurança, prevenção, não-discriminação e responsabilidade. Neste sentido, a obrigação do estagiário de manter o sigilo dos dados significa que ele não está autorizado a transmitir os dados de que tem conhecimento no exercício de suas tarefas a terceiros que não estão autorizados a processar ou utilizar tais dados de uma forma específica.',
      }),
    ],
    spacing: { before: 400 },
  });
}

export function paragrafoPrimeiro13(): Paragraph {
  return new Paragraph({
    children: [
      new TextRun({
        text: 'Parágrafo nono - ',
        bold: true,
        allCaps: true,
        padding: { top: 0, right: 10, bottom: 110, left: 10 },
        size: 18,
        alignment: 'center',
      }),
      new TextRun({
        text: 'A instituição de ensino se compromete a tratar os dados pessoais do aluno/ estagiário necessários para as atividades de estágio em atendimento a legislação de privacidade aplicável, incluindo, mas não se limitando, à Lei nº 13.709/18 (LGPD).',
      }),
    ],
    spacing: { before: 400 },
  });
}

export function tituloSubdefensor(): Paragraph {
  return new Paragraph({
    children: [
      new TextRun({
        text: 'JESUS JAIRO ALMEIDA DE LACERDA',
        bold: true,
        size: 20,
        color: 'FF0000',
      }),
      new TextRun({
        break: 1,
      }),
      new TextRun({
        text: 'Subdefensor Público-Geral',
        bold: true,
        size: 18,
      }),
    ],
    alignment: 'center',
    spacing: { before: 600, after: 500 },
  });
}

export function tituloCarregadoEstagio(): Paragraph {
  return new Paragraph({
    children: [
      new TextRun({
        text: 'ALYSSON YAGO DOS SANTOS',
        bold: true,
        size: 20,
        color: 'FF0000',
      }),
      new TextRun({
        break: 1,
      }),
      new TextRun({
        text: 'Estagiário(a)',
        bold: true,
        size: 18,
      }),
    ],
    alignment: 'center',
    spacing: { before: 600, after: 500 },
  });
}

export function tituloRodape(): Paragraph {
  return new Paragraph({
    children: [
      new TextRun({
        text: 'RESPONSÁVEL PELA INSTITUIÇÃO DE ENSINOS',
        bold: true,
        size: 20,
      }),
      new TextRun({
        break: 1,
      }),
      new TextRun({
        text: 'Centro Universitário Estácio de Sergipe',
        bold: true,
        size: 18,
      }),
    ],
    alignment: 'center',
    spacing: { before: 600, after: 500 },
  });
}
